import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { getPaymentInfoErrors, getBankInfoErrors, getPersonalInfoErrors } from "../utils";
import styles from "./FullPaymentForm.module.less";
import moment from "moment";
import PersonalInfoFields from "../PersonalInfoFields/PersonalInfoFields";
import PaymentInfoFields from "../PaymentInfoFields/PaymentInfoFields";
import Form from "assets/scripts/components/common/form/Form/Form";
import BankInfoFields from "../BankInfoFields/BankInfoFields";
const SUBMIT_LABEL = (<FormattedMessage id="forms.payNow.submit" defaultMessage="Pay"/>);
const FullPaymentForm = (props) => {
    const now = moment();
    const { value, disableBankSave } = props;
    const errors = {
        payment: getPaymentInfoErrors(value, props.group, now, props.settlementOffer != null, false),
        bank: getBankInfoErrors(value),
        personal: getPersonalInfoErrors(value)
    };
    const isValid = errors.payment.valid && [
        ...Object.values(errors.bank),
        ...Object.values(errors.personal)
    ].every(it => it == null);
    return (<Fragment>
			<div className="vr vr_x4">
				<h2 className="hdg">
					<FormattedMessage id="forms.payNow.header" defaultMessage="Make a Payment"/>
				</h2>
			</div>
			<Form className={styles.form} isBusy={props.isLoading} isValid={isValid} onSubmit={props.onContinue} submitLabel={SUBMIT_LABEL} error={props.globalError}>
				<fieldset className="fieldset fieldset-depth-0">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.payNow.legend" defaultMessage="Billing Information"/>
						</span>
					</legend>

					<fieldset className="fieldset fieldset-depth-1">
						<legend>
							<h1 className="hdg_2 vr vr_x2">
								<FormattedMessage id="forms.payNow.paymentInfo.legend" defaultMessage="Payment Information"/>
							</h1>
						</legend>

						<PaymentInfoFields errors={errors.payment} {...props}/>

						<BankInfoFields disableBankSave={disableBankSave || false} errors={errors.bank} {...props}/>
					</fieldset>

					<fieldset className="fieldset fieldset-depth-1">
						<legend>
							<h1 className="hdg_2 vr vr_x2">
								<FormattedMessage id="forms.payNow.personalInfo.legend" defaultMessage="Personal Information"/>
							</h1>
						</legend>

						<PersonalInfoFields errors={errors.personal} {...props}/>
					</fieldset>

				</fieldset>
			</Form>
		</Fragment>);
};
export default FullPaymentForm;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/FullPaymentForm/FullPaymentForm.tsx